import React, { useContext } from "react";
import { Outlet, Navigate } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";
import { PATHS } from "../constants/paths";

const PrivateRoutes = () => {
  const {
    state: { user, isAuthenticated },
  } = useContext(AuthContext);

  const isValidToken = user.isValidToken;

  if (isAuthenticated && isValidToken) {
    return <Outlet />;
  } else if (isAuthenticated && !isValidToken) {
    return <Navigate to={PATHS.validate2fa} />;
  } else {
    return <Navigate to={PATHS.login} />;
  }
};

export default PrivateRoutes;
